import { gql } from '@apollo/client/core';
/* eslint-disable import/prefer-default-export */

export const UPDATE_JOB_APPLICATION_DISMISSAL = gql`
  mutation ($applicationUuids: [UUID!]!, $dismiss: Boolean!) {
    updateJobApplicationDismissal(ids: $applicationUuids, dismiss: $dismiss) {
      jobApplications {
        id
      }
    }
  }
`;

export const REPLY_TO_JOB_APPLICATION_WITH_SENDBIRD = gql`
  mutation ($jobApplicationId: UUID!, $message: String!) {
    replyToJobApplicationWithSendbird(jobApplicationId: $jobApplicationId, message: $message) {
      channelUrl
    }
  }
`;
